export const rootPaths = {
  componentDocsRoot: 'component-docs',
  documentationRoot: 'documentation',
};

const routePaths = {
  alert: `/${rootPaths.componentDocsRoot}/alert`,
  appBar: `/${rootPaths.componentDocsRoot}/app-bar`,
  autocomplete: `/${rootPaths.componentDocsRoot}/autocomplete`,
  breadcrumbs: `/${rootPaths.componentDocsRoot}/breadcrumbs`,
  button: `/${rootPaths.componentDocsRoot}/button`,
  buttonGroup: `/${rootPaths.componentDocsRoot}/button-group`,
  accordion: `/${rootPaths.componentDocsRoot}/accordion`,
  avatar: `/${rootPaths.componentDocsRoot}/avatar`,
  backdrop: `/${rootPaths.componentDocsRoot}/backdrop`,
  badge: `/${rootPaths.componentDocsRoot}/badge`,
  bottomNavigation: `/${rootPaths.componentDocsRoot}/bottom-navigation`,
  box: `/${rootPaths.componentDocsRoot}/box`,
  card: `/${rootPaths.componentDocsRoot}/card`,
  chip: `/${rootPaths.componentDocsRoot}/chip`,
  container: `/${rootPaths.componentDocsRoot}/container`,
  checkbox: `/${rootPaths.componentDocsRoot}/checkbox`,
  dataGrid: `/${rootPaths.componentDocsRoot}/data-grid`,
  dialog: `/${rootPaths.componentDocsRoot}/dialog`,
  fab: `/${rootPaths.componentDocsRoot}/floating-action-button`,
  link: `/${rootPaths.componentDocsRoot}/link`,
  menu: `/${rootPaths.componentDocsRoot}/menu`,
  popover: `/${rootPaths.componentDocsRoot}/popover`,
  popper: `/${rootPaths.componentDocsRoot}/popper`,
  select: `/${rootPaths.componentDocsRoot}/select`,
  slider: `/${rootPaths.componentDocsRoot}/slider`,
  speedDial: `/${rootPaths.componentDocsRoot}/speed-dial`,
  stepper: `/${rootPaths.componentDocsRoot}/stepper`,
  switch: `/${rootPaths.componentDocsRoot}/switch`,
  drawer: `/${rootPaths.componentDocsRoot}/drawer`,
  divider: `/${rootPaths.componentDocsRoot}/divider`,
  grid: `/${rootPaths.componentDocsRoot}/grid`,
  imageList: `/${rootPaths.componentDocsRoot}/image-list`,
  list: `/${rootPaths.componentDocsRoot}/list`,
  modal: `/${rootPaths.componentDocsRoot}/modal`,
  pagination: `/${rootPaths.componentDocsRoot}/pagination`,
  paper: `/${rootPaths.componentDocsRoot}/paper`,
  progress: `/${rootPaths.componentDocsRoot}/progress`,
  rating: `/${rootPaths.componentDocsRoot}/rating`,
  skeleton: `/${rootPaths.componentDocsRoot}/skeleton`,
  snackbar: `/${rootPaths.componentDocsRoot}/snackbar`,
  stack: `/${rootPaths.componentDocsRoot}/stack`,
  tabs: `/${rootPaths.componentDocsRoot}/tabs`,
  textfield: `/${rootPaths.componentDocsRoot}/textfield`,
  radio: `/${rootPaths.componentDocsRoot}/radio`,
  toggleButton: `/${rootPaths.componentDocsRoot}/toggle-button`,
  table: `/${rootPaths.componentDocsRoot}/table`,
  timeline: `/${rootPaths.componentDocsRoot}/timeline`,
  tooltip: `/${rootPaths.componentDocsRoot}/tooltip`,
  transferList: `/${rootPaths.componentDocsRoot}/transfer-list`,
  typography: `/${rootPaths.componentDocsRoot}/typography`,
  icon: `/${rootPaths.componentDocsRoot}/icon`,
  swiper: `/${rootPaths.componentDocsRoot}/swiper`,
  scrollbar: `/${rootPaths.componentDocsRoot}/scrollbar`,
  echarts: `/${rootPaths.componentDocsRoot}/echarts`,
  dateTimePickers: `/${rootPaths.componentDocsRoot}/date-time-pickers`,
  dateRangePicker: `/${rootPaths.componentDocsRoot}/date-range-picker`,
  fileUploader: `/${rootPaths.componentDocsRoot}/file-uploader`,
  lightbox: `/${rootPaths.componentDocsRoot}/lightbox`,
  editor: `/${rootPaths.componentDocsRoot}/editor`,
  emojiPicker: `/${rootPaths.componentDocsRoot}/emoji-picker`,
  resizable: `/${rootPaths.componentDocsRoot}/resizable`,

  introduction: `/${rootPaths.documentationRoot}/introduction`,
  gettingStared: `/${rootPaths.documentationRoot}/getting-started`,
  configuration: `/${rootPaths.documentationRoot}/configuration`,
  folderStructure: `/${rootPaths.documentationRoot}/folder-structure`,
  routing: `/${rootPaths.documentationRoot}/routing`,
  theming: `/${rootPaths.documentationRoot}/theming`,
  icons: `/${rootPaths.documentationRoot}/icons`,
  localization: `/${rootPaths.documentationRoot}/localization`,
  authentication: `/${rootPaths.documentationRoot}/authentication`,
  layouts: `/${rootPaths.documentationRoot}/layouts`,
  apiCalls: `/${rootPaths.documentationRoot}/api-calls`,
  dependencies: `/${rootPaths.documentationRoot}/dependencies`,
  changelog: `/${rootPaths.documentationRoot}/changelog`,
  migration: `/${rootPaths.documentationRoot}/migration`,
};

export default routePaths;
